var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "receivedialog",
      style: { display: _vm.receive ? "block" : "none" }
    },
    [
      _c("div", { staticClass: "dialog" }, [
        _c("div", { staticClass: "close" }, [
          _c("i", {
            staticClass: "iconfont icon-guanbi-1",
            on: { click: _vm.close }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "dialogmain" }, [
          _c("div", { staticClass: "header" }, [
            _vm.addtitle !== ""
              ? _c("b", [_vm._v(_vm._s(_vm.$t("300167")))])
              : _c("b", [
                  _vm._v(
                    _vm._s(
                      _vm.reward ? _vm.$t(_vm.gifttitle) : _vm.$t(_vm.title)
                    )
                  )
                ]),
            _vm._v(" "),
            _vm.addtitle === "" && _vm.content
              ? _c("p", [_c("b", [_vm._v(_vm._s(_vm.$t(_vm.content)))])])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "main" }, [
            _c("p", [_vm._v(_vm._s(_vm.$t("300172")))]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stuff", attrs: { id: "stuff" } },
              _vm._l(_vm.getconfig, function(item, index) {
                return _c(
                  "dl",
                  { key: index, class: { active: item.isUsed } },
                  [
                    _c("dt", [
                      _c("img", {
                        attrs: {
                          src: require("../assets/images/" +
                            _vm.gift[item.rewardType - 1].nosigin +
                            ".png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(_vm.gift[item.rewardType - 1].gifttitle)
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.rewardConfigList.length > 0
                      ? _c("dd", [
                          _c("span", { class: { active: item.isUsed } }, [
                            _vm._v(
                              _vm._s(
                                !item.isUsed
                                  ? _vm.$t("300174", {
                                      num: _vm.rewardConfigList[index].seriesNum
                                    })
                                  : _vm.$t("300173")
                              )
                            )
                          ])
                        ])
                      : _vm._e()
                  ]
                )
              }),
              0
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "receivefoot" }, [
          _c("span", { on: { click: _vm.close } }, [
            _vm._v(_vm._s(_vm.$t("300141")))
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c2199e1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c2199e1","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compontents/Receivedialog.vue
// module id = X2gx
// module chunks = 0